import styled from "styled-components";

// BRAND COLORS
export const lkBrandBlueLight = "#008CD7";
export const lkBrandBlue = "#005C8E";
export const lkBrandBlueDark = "#004265";

// THEME COLORS- light
export const primaryBg = "#EFEFEF";
export const secondaryBg = "#FFFFFF";
export const primaryText = "#3C3C3C";
export const secondaryText = "#7E7E7E";

// // THEME COLORS- Dark
// export const primaryBg = "#000000";
// export const secondaryBg = "#1E1E1E";
// export const primaryText = "#FFFFFF";
// export const secondaryText= "#C1C1C1";

// LK- Defined colors
// Shades of Red
export const lkRed1 = "#F0A1A4";
export const lkRed2 = "#E56367";
export const lkRed = "#DC272D";
export const lkRed3 = "#9D191E";
export const lkRed4 = "#5E0F12";

// Shades of Green
export const lkGreen1 = "#85CCA2";
export const lkGreen2 = "#47B273";
export const lkGreen = "#00943D";
export const lkGreen3 = "#006B2C";
export const lkGreen4 = "#00471D";

// Shades of Yellow
export const lkYellow1 = "#FFEB92";
export const lkYellow2 = "#FFDD49";
export const lkYellow = "#FFD000";
export const lkYellow3 = "#B69500";
export const lkYellow4 = "#6D5900";

// Shades of Orange
export const lkOrange1 = "#F7C891";
export const lkOrange2 = "#F2AC59";
export const lkOrange = "#EE8C19";
export const lkOrange3 = "#AB6512";
export const lkOrange4 = "#72430C";

// Shades of blue
export const lkBlue1 = "#88B6F8";
export const lkBlue2 = "#4C90F8";
export const lkBlue = "#0766F6";
export const lkBlue3 = "#0549B1";
export const lkBlue4 = "#033176";

// Shades of gray
export const lkGray1 = "#C1C1C1";
export const lkGray2 = "#A2A2A2";
export const lkGray = "#7E7E7E";
export const lkGray3 = "#5B5B5B";
export const lkGray4 = "#3C3C3C";

export const lkLightBg = "#EFEFEF";
export const lkDarkBg = "#1E1E1E";

export const lkWhite = "#FFFFFF";
export const lkBlack = "#000000";

export const lkprimary = "#005C8E";
export const lkred = "#DC272D";
export const lkltblue = "#1C8BCB";
export const lkgreen = "#00943D";
export const lkyellow = "#FBCA2F";
export const lkorange = "#EE8C19";

export const DivHoverEffect = styled.div`
  font-size: 20px;
  cursor: pointer;
  transition: color 0.3s ease;
  &:hover {
    color: ${lkBrandBlueLight};
  }
`;
export const ChargerDiv = styled.div`
  color: #000;
  font-weight: bold;
  cursor: pointer;
  transition: color 0.3s ease;

  &:hover {
    text-decoration: underline;
    color: ${lkBrandBlueLight};
  }
`;

export const modalStyle =(width,height)=> {
 return { overlay: { backgroundColor: "rgba(0, 0, 0, 0.5)" },
  content: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: width,
    height: height,
    padding: "15px",
    borderRadius: "10px",
    backgroundColor: "#fff",
    overflowY: "auto",
    zIndex: 1005,
    scrollbarWidth: "thin",
    scrollbarColor: "rgba(0,92,142,0.6) #f0f0f0",
  },}
};

export const modalStyleRFID = (width = "30%", height = "100%", isOpen = false) => ({
  content: {
    position: "fixed",
    top: "9%",
    right: "0",
    bottom: "0",
    left:"auto",
    width: width,
    height: height,
    margin: "0",
    padding: "20px",
    background: "#fff",
    border: "none",
    borderRadius: "0",
    overflow: "auto",
    transition: "transform 0.4s ease-in-out",
    transform: isOpen ? "translateX(0%)" : "translateX(100%)", // Slide from right
  },
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.4)",
    zIndex: 1050,
    transition: "opacity 0.3s ease-in-out",
  },
});
